  export const importModuleFromExternalUrl = async (moduleUrl) => {
    // Use native dynamic import at runtime so bundlers don't try to resolve external URLs.
    const runtimeImport = new Function('url', 'return import(url);');
    return await runtimeImport(moduleUrl);
}
